// @flow
import "routes/public/Home2/Home.css";
import React, { Component } from "react";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import { withStyles } from "@material-ui/core";
// import public pages

const styles = (theme) => ({
  noPaperContainer: {
    width: "100%",
    margin: 0,
    marginTop: "-12px",
  },
  paperContainer: {
    width: "100%",
    margin: 0,
  },
  paperInnerWrap: {
    padding: 40,
    border: "1px rgb(243, 243, 243) solid",
    marginTop: "-10px",
    [theme.breakpoints.down("sm")]: {
      overflowX: "scroll",
      overflowY: "hidden",
      padding: 14,
    },
    WebkitOverflowScrolling: "touch",
  },
});

type Props = Page & {
  classes: Object,
};

class PublicPageWrapper extends Component<Props> {
  componentDidMount() {
    this.props.updatePersistent(true);
  }

  componentWillUnmount() {
    this.props.updatePersistent(false);
  }

  render() {
    const { children, noPaper, widthLg, classes } = this.props;
    const widthLargeApplied = widthLg ? widthLg : 10;
    if (noPaper) {
      return (
        <Grid container spacing={2} justify="center">
          <Grid item xs={12} lg={12}>
            {children}
          </Grid>
        </Grid>
      );
    }
    return (
      <Grid
        container
        spacing={2}
        justify="center"
        className={classes.paperContainer}
      >
        <Grid item xs={12} lg={widthLargeApplied}>
          <Paper elevation={0} className={classes.paperInnerWrap}>
            {children}
          </Paper>
        </Grid>
      </Grid>
    );
  }
}

export default withStyles(styles)(PublicPageWrapper);
